var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 38,
    viewBox: "0 0 29 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5007 22C22.7128 22 23.0125 25.7912 24.3291 27.1281C25.6457 28.4649 28.1673 28.7692 28.1673 30C28.1673 31.2308 25.6457 31.5351 24.3291 32.8719C23.0125 34.2088 22.7128 38 21.5007 38C20.2885 38 19.9888 34.2088 18.6722 32.8719C17.3556 31.5351 14.834 31.2308 14.834 30C14.834 28.7692 17.3556 28.4649 18.6722 27.1281C19.9888 25.7912 20.2885 22 21.5007 22Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83398 11C6.74308 11 6.96786 13.8434 7.9553 14.846C8.94275 15.8487 10.834 16.0769 10.834 17C10.834 17.9231 8.94275 18.1513 7.9553 19.154C6.96786 20.1566 6.74308 23 5.83398 23C4.92489 23 4.70011 20.1566 3.71266 19.154C2.72522 18.1513 0.833984 17.9231 0.833984 17C0.833984 16.0769 2.72522 15.8487 3.71266 14.846C4.70011 13.8434 4.92489 11 5.83398 11Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 0C15.9394 0 16.0892 1.8956 16.7475 2.56403C17.4058 3.23246 18.6667 3.38462 18.6667 4C18.6667 4.61538 17.4058 4.76754 16.7475 5.43597C16.0892 6.1044 15.9394 8 15.3333 8C14.7273 8 14.5774 6.1044 13.9191 5.43597C13.2608 4.76754 12 4.61538 12 4C12 3.38462 13.2608 3.23246 13.9191 2.56403C14.5774 1.8956 14.7273 0 15.3333 0Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats);
export default __webpack_public_path__ + "static/media/stats.09d0a975.svg";
export { ForwardRef as ReactComponent };